let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dYKkq")).then(() => parcelRequire('huQ3W'));